export default __webpack_public_path__ + "static/media/pieczatka3.1c3da29c.gif";